import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';

export function useHosts() {
  return useQuery({
    queryKey: ['hosts'],
    queryFn: async () => api.getHosts(),
    staleTime: 60_000,
  });
}
